import React, {PropsWithChildren, useEffect} from 'react';
import {useNavigate} from "react-router";
import useAuth from "../../components/hooks/useAuth";
import {routes} from "../../utils";
import {Pages} from "../../components/layout";
import Loading from "../../components/Loading";

/**
 * The children components can only be accessed by logged-in users.
 */
export default function ProtectedRoute({ children }: PropsWithChildren<{}>) {
    const { user, isLoading } = useAuth()
    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoading && !user) {
            navigate(routes.loginWithRedirect(window.location.pathname));
        }
    }, [user, isLoading])

    return user
        ? <>{children}</>
        : <Pages.Centred ><Loading /></Pages.Centred>;
}
